import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useCurrentBreakpoint } from "../../hooks/useCurrentBreakpoint";
import { ReferralStatsCard, ReferralStatsProgressBar } from "./components";
import { useUserReferralData } from "./hooks";
import styles from "./LoyaltyReferralStats.module.scss";
const themes = {
    light: "light-theme",
    dark: "dark-theme",
};
const EDITOR_DATA = {
    isLoading: false,
    isAllAchievementsDone: false,
    totalUserReferrals: 5,
    referredFriendsCountForStatistics: 5,
    friendsReferralsUntilNextAchievement: 5,
    milestones: [
        {
            mileStonePointsValue: 100,
            referralNumber: 2,
        },
        {
            mileStonePointsValue: 200,
            referralNumber: 5,
        },
        {
            mileStonePointsValue: 400,
            referralNumber: 10,
        },
        {
            mileStonePointsValue: 600,
            referralNumber: 15,
        },
    ],
    pointsEarned: 300,
    isComponentHidden: false,
};
export const LoyaltyReferralStats = ({ heading, subHeading, friendsReferredDescription, friendsReferredInfoHeading, friendsReferredPoints, friendsReferredSubText, pointsEarnedDescription, pointsEarnedCtaLink, pointsEarnedCtaText, nextTierInfoDescription, nextTierInfoCtaLink, nextTierInfoCtaText, progressBlockBg, progressBlockBgTablet, progressBlockBgMobile, progressBlockHeading, progressBlockDescription, progressBlockHeadingAllDone, progressBlockDescriptionAllDone, progressBarText, milestonesText, achievementsDoneHeading, achievementsDoneText, isInEditor, theme, isStatsVisible, isAnimatedNumberEnabled = false, }) => {
    const { mainBreakpoint } = useCurrentBreakpoint();
    const userReferralData = useUserReferralData();
    const { isLoading, friendsReferralsUntilNextAchievement, isAllAchievementsDone, totalUserReferrals, referredFriendsCountForStatistics, pointsEarned, milestones, isComponentHidden, } = isInEditor ? EDITOR_DATA : userReferralData;
    const themeClassName = themes[theme];
    const isMobileOrTablet = ["xs", "sm"].includes(mainBreakpoint);
    const getBgImage = () => {
        if (mainBreakpoint === "xs") {
            return progressBlockBgMobile;
        }
        if (mainBreakpoint === "sm") {
            return progressBlockBgTablet;
        }
        return progressBlockBg;
    };
    const [untilNextAchievementHeading, untilNextAchievementText, progressBlockHeadingText, progressBlockDescriptionText,] = isAllAchievementsDone
        ? [achievementsDoneHeading, achievementsDoneText, progressBlockHeadingAllDone, progressBlockDescriptionAllDone]
        : [friendsReferralsUntilNextAchievement, nextTierInfoDescription, progressBlockHeading, progressBlockDescription];
    if (!isInEditor && (isLoading || isComponentHidden)) {
        return null;
    }
    return (_jsxs("div", { className: classNames(styles.wrapper, themeClassName), "data-testid": "loyaltyReferralStats", children: [_jsx("h2", { className: styles.heading, children: heading }), _jsx("h3", { className: styles.subHeading, children: subHeading }), _jsxs("div", { className: styles.statsWrapper, children: [_jsx(ReferralStatsCard, { count: String(referredFriendsCountForStatistics), badgeText: friendsReferredPoints, additionalText: friendsReferredSubText, headerText: friendsReferredDescription, informationText: friendsReferredInfoHeading }), _jsx(ReferralStatsCard, { isRedirect: true, count: String(pointsEarned), href: pointsEarnedCtaLink, headerText: pointsEarnedDescription, ctaButtonText: pointsEarnedCtaText, isAnimatedNumberEnabled: isAnimatedNumberEnabled }), isStatsVisible && (_jsx(ReferralStatsCard, { isRedirect: true, isReferralCTA: true, href: nextTierInfoCtaLink, count: String(untilNextAchievementHeading), headerText: untilNextAchievementText, ctaButtonText: nextTierInfoCtaText, isAllAchievementsDone: false }))] }), isStatsVisible && (_jsxs("div", { className: classNames(styles.statsProgressWrapper, "dark-theme"), style: { "--referral-stats-bg": `url(${getBgImage()})` }, children: [_jsxs("div", { className: styles.statsProgressText, children: [_jsx("h2", { className: styles.statsProgressHeading, children: progressBlockHeadingText }), _jsx("p", { className: styles.statsProgressDescription, children: progressBlockDescriptionText })] }), _jsx("div", { className: classNames(styles.statsProgressBar, "light-theme"), children: _jsx(ReferralStatsProgressBar, { milestones: milestones, userCurrentReferralNumber: totalUserReferrals, progressBarText: progressBarText, milestonesText: milestonesText, isMobileOrTablet: isMobileOrTablet }) })] }))] }));
};
//# sourceMappingURL=LoyaltyReferralStats.js.map